/**
 * Melian Dialogue — company & payment details.
 *
 * Single source of truth used across footer, legal pages, compliance page,
 * FAQ, BrokerSignup, and the AgencyTrialBanner. If any of these values change,
 * update ONLY this file.
 */

export const COMPANY = {
    legal_name:      "Melian Dialogue Limited",
    company_number:  "PVT-27ULY98K",
    kra_pin:         "P052416974R",
    registered_office: "P.O. Box B1003, Urban Oasis Apartments, Kingara Road, Lavington, Nairobi",
    email_billing:   "billing@meliandialogue.com",
    email_support:   "support@meliandialogue.com",
    country:         "Kenya",
};

export const BANK = {
    bank_name:      "I & M Bank",
    account_name:   "Melian Dialogue Limited",
    account_number: "01006581796350",
    branch:         "One Park Branch",
    branch_address: "P.O. Box 30238 - 00100 Nairobi",
    currency:       "KES",
    // Reference format brokers should use when wiring — keeps admin
    // reconciliation trivial.
    reference_hint: "Use your institution name + license number as the reference",
};

export const PRICING_ANNUAL = {
    cma_kes: 500000,
    moe_kes: 350000,
};
